module.exports = __webpack_public_path__ + "cd790db43aa792f6ad19f861053089b8.svg";